import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
  standalone: true
})
export class DurationPipe implements PipeTransform {
  #msInMin = 60000;
  #minInHour = 60;
  #minInDay = 1440;

  transform(startedAt: Date | string, endDate: number | string | null = null): string {
    const endedAt = typeof endDate === 'number' ? endDate : new Date(endDate === null ? Date.now() : endDate).getTime();
    const minutes = (endedAt - new Date(startedAt).getTime()) / this.#msInMin;

    if (minutes < this.#minInHour) {
      return `${minutes.toFixed()} min`;
    } else if (minutes >= this.#minInHour && minutes < this.#minInDay) {
      const hours = Math.floor(minutes / this.#minInHour);
      const remMinutes = minutes % this.#minInHour;

      return `${this.getHours(hours)} ${remMinutes.toFixed()} min`;
    } else {
      const days = Math.floor(minutes / this.#minInDay);
      const remMinutes = minutes % this.#minInDay;
      const hours = Math.floor(remMinutes / this.#minInHour);

      return `${this.getDays(days)} ${this.getHours(hours)}`;
    }
  }

  private getHours(hours: number): string {
    return this.ifOne(hours) ? `${hours} hour` : `${hours} hours`;
  }

  private getDays(days: number): string {
    return this.ifOne(days) ? `${days} day` : `${days} days`;
  }

  private ifOne(num: number): boolean {
    return num === 1;
  }
}
